var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test-result"},[_c('content-box',{attrs:{"min-height":'646px'}},[_c('ocr-list',{staticClass:"ocr-list",attrs:{"ocrList":_vm.ocrList},on:{"clickResult":_vm.clickResult}}),_c('test-result-list',{staticClass:"test-list",attrs:{"imgDataId":_vm.testResultList.id,"testResultList":_vm.testResultList}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }